import React, { useState } from "react";
import { Link, Outlet, useLocation } from "react-router-dom"; // ← Renders child routes

const WEEKLY_PICKS_BANNER_STORAGE_KEY = "weekly-picks-banner-collapsed";
const WEEKLY_PICKS_BANNER_VISIBLE = false;

const Layout: React.FC = () => {
  const location = useLocation();
  const [isBannerCollapsed, setIsBannerCollapsed] = useState(
    () => window.localStorage.getItem(WEEKLY_PICKS_BANNER_STORAGE_KEY) !== "false",
  );
  const isHomePage = location.pathname === "/";

  const collapseBanner = () => {
    window.localStorage.setItem(WEEKLY_PICKS_BANNER_STORAGE_KEY, "true");
    setIsBannerCollapsed(true);
  };

  const expandBanner = () => {
    window.localStorage.setItem(WEEKLY_PICKS_BANNER_STORAGE_KEY, "false");
    setIsBannerCollapsed(false);
  };

  return (
    <div
      style={{ minHeight: "100vh", display: "flex", flexDirection: "column", marginTop: "25px" }}
    >
      {WEEKLY_PICKS_BANNER_VISIBLE && isHomePage && !isBannerCollapsed && (
        <aside className="desktop-catalog-banner" aria-label="Седмични предложения">
          <button
            type="button"
            className="desktop-catalog-banner__close"
            onClick={collapseBanner}
            aria-label="Затвори седмичните предложения"
          />
          <Link to="/aktualni/promoci/katalozi/" className="desktop-catalog-banner__cta">
            Виж офертите
          </Link>
        </aside>
      )}
      {WEEKLY_PICKS_BANNER_VISIBLE && isHomePage && isBannerCollapsed && (
        <button
          type="button"
          className="desktop-catalog-banner-tab"
          onClick={expandBanner}
          aria-label="Покажи седмичните предложения"
        >
          Седмични предложения
        </button>
      )}
      <main style={{ flex: 1 }}>
        <Outlet /> {/* ← Renders Home/StorePage/etc. */}
      </main>
    </div>
  );
};

export default Layout;
